import { createFileRoute } from "@tanstack/react-router";
import { SignUpPage } from "~/components/orcaloops/SignUpDoor.tsx";
import { signUpHead, validateLoginSearch } from "~/lib/login-search.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * Orcaloops self-service sign-up door — the sibling of the `/orca/login` door.
 *
 * The orca subdomain is a wildcard-prefix host, so `orcaloops.ai/sign-up`
 * rewrites to this route at `/orca/sign-up` (`/sign-up` is not in
 * `SHARED_NON_PREFIXED_PATHS`), and `isOrcaPublicPath` keeps the door out of
 * the `/orca` layout's `requireAdmin` guard.
 *
 * The door is our own v5 card (`components/orcaloops/SignUpDoor.tsx`) driven by
 * Clerk's headless sign-up API. The page component is NOT exported, so
 * TanStack's code splitter moves it — and the door, the frame and Clerk's hook
 * with it — into a route chunk instead of the always-loaded entry. The frame's
 * sheet arrives as a `<link>` from `head()`.
 *
 * After sign-up the visitor lands on `/orca`, the internal orca root, which the
 * output rewrite renders as `/` on orcaloops.ai.
 *
 * @since 1.0.0
 */

/**
 * The door's `<head>`: `Create account — Orcaloops`, `noindex`, and the
 * orcaloops frame's stylesheet. Shared with the `$` catch-all.
 *
 * @since 1.0.0
 */
export const signUpDoorHead = () => ({ ...signUpHead("Orcaloops"), links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/sign-up/")({
  validateSearch: validateLoginSearch,
  head: signUpDoorHead,
  component: SignUpIndexPage,
});

function SignUpIndexPage() {
  return <SignUpPage search={Route.useSearch()} />;
}
